<template>
  <div>
    <Loader :loading="showLoader" />
    <v-toolbar color="#222222" flat dense class="mb-4">
      <v-icon color="#337b52" class="ml-2" size="40" @click="goBack">
        mdi-arrow-left-bold-circle
      </v-icon>
      <v-toolbar-title style="font-family: 'Material Design Icons'; font-size: 25px !important">
        {{ toobarTitle }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <img :src="logo" class="toolbar-icon" /> -->
    </v-toolbar>

    <v-container fluid class="main-content px-4">
      <v-row justify="center" align="stretch" class="ma-0">
        <v-col v-for="(card, index) in cards" :key="index" cols="12" sm="6" md="4" lg="3" class="pa-3 d-flex">
          <v-card class="elegant-card" :class="{ 'active-card': selectedCard === index }"
            @mouseover="hoverCard(index, true)" @mouseleave="hoverCard(index, false)" @click="selectCard(index)">
            <img :src="card.image" class="card-image" />
            <div class="card-bottom">
              <div class="card-title">{{ card.text }}</div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- PDF Viewer Modal -->
    <div v-if="pdfDialog" class="modal-overlay" @click.self="closePdf">
      <div class="modal-content">
        <button class="modal-close" @click="closePdf">✖</button>
        <div class="pdf-viewer">
          <PDF v-if="pdfSrc" :src="pdfSrc" @onComplete="onPdfComplete" class="pdf-viewer-content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, onUnmounted } from "vue";
import PDF from "pdf-vue3";
import Loader from "@/components/Loader.vue";
import { getToolBarLogo } from "@/assets/Branding/branding.js";
import { useRouter } from "vue-router";
import hoxtonalterwall from "@/assets/Branding/Artinvest/HotelViewPictures/hoxtonalterwallNEW.jpg";
import hoxton from "@/assets/Branding/Artinvest/HotelViewPictures/hoxton.jpg";
import cotp from "@/assets/Branding/Artinvest/HotelViewPictures/cotp.png";
import artinvesthotel from "@/assets/Branding/Artinvest/HotelViewPictures/artinvesthotel.jpg";

export default {
  name: 'HotelView',
  components: {
    Loader,
    PDF,
  },
  setup() {
    const showLoader = ref(true);
    const logo = ref("");
    const router = useRouter();
    const selectedCard = ref(0);
    const pdfDialog = ref(false);
    const pdfSrc = ref("");
    const pdfLoading = ref(true);
    const toobarTitle = ref("Hotel – The Hoxton");

    const cards = ref([
      { text: "The Hoxton – Alter Wall", image: hoxtonalterwall, hover: false },
      { text: "The Hoxton – Standorte", image: hoxton, hover: false },
      { text: "COTP Group", image: cotp, hover: false },
      { text: "Art-Invest Hotels", image: artinvesthotel, hover: false },
    ]);

    const goBack = () => {
      router.go(-1);
    };

    const hoverCard = (index, hover) => {
      cards.value[index].hover = hover;
    };

    const selectCard = (index) => {
      selectedCard.value = index;

      // Handle Art-Invest Hotels card (index 3) - open PDF
      if (index === 3) {
        viewPdf("/pdfs/Artinvest-hotel-presentation.pdf");
      }
      // Handle other cards - navigate to routes
      else if (index === 0) {
        router.push({ name: "HoxtonAlterWall" });
      }
      else if (index === 1) {
        router.push({ name: "HoxtonTheBrand" });
      }
      else if (index === 2) {
        router.push({ name: "CotpGroup" });
      }
    };

    const viewPdf = (link) => {
      const isPpt = link.endsWith(".ppt") || link.endsWith(".pptx");
      pdfSrc.value = isPpt
        ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(link)}`
        : link;
      pdfDialog.value = true;
    };

    const closePdf = () => {
      pdfDialog.value = false;
    };

    const onPdfComplete = () => {
      showLoader.value = false;
    };

    const isMobile = ref(window.innerWidth < 1024);

    const updateIsMobile = () => {
      isMobile.value = window.innerWidth < 1024;
    };

    window.addEventListener('resize', updateIsMobile);

    onMounted(async () => {
      logo.value = await getToolBarLogo();
      setTimeout(() => {
        showLoader.value = false;
      }, 800);
      updateIsMobile();
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateIsMobile);
    });

    return {
      showLoader,
      logo,
      goBack,
      cards,
      hoverCard,
      selectedCard,
      selectCard,
      isMobile,
      toobarTitle,
      pdfDialog,
      pdfSrc,
      pdfLoading,
      viewPdf,
      closePdf,
      onPdfComplete
    };
  }
};
</script>

<style scoped>
.toolbar-icon {
  height: 30px;
  align-self: center;
  margin-right: 20px;
}

.elegant-card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
  cursor: pointer;
}

/* .elegant-card:hover {
  transform: scale(1.03);
} */

.card-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.card-bottom {
  background-color: #ffffff;
  width: 100%;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
}

.card-title {
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  color: #000000;
  font-weight: bold;
}

/* PDF Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  position: relative;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 95%;
  max-width: 1000px;
  height: 90%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.modal-close {
  position: absolute;
  top: -15px;
  right: -0.1px;
  background: #ffffff;
  border: none;
  font-size: 24px;
  cursor: pointer;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-close:hover {
  background: #f1f1f1;
}

.pdf-viewer {
  flex: 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.pdf-viewer-content {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>